import { getService } from "../utils/Request";

interface loginProps {
  Username: string | number;
  Password: string | number;
  loginId?: string | number;
  CaptchaId?: string | number;
  Captcha?: string | number;
}
export function login(data: loginProps) {
  return getService()({
    url: "/Account/login",
    method: "post",
    data: { ...data },
  });
}

interface checkVerificationProps {
  loginId?: string | number;
  code?: string | number;
}
export function checkVerificationCode(data: checkVerificationProps) {
  return getService()({
    url: "/Account/checkVerificationCode",
    method: "post",
    data: { ...data },
  });
}

interface sendsmsProps {
  loginId?: string | number;
}
export function sendSms(data: sendsmsProps) {
  return getService()({
    url: `/Account/sendsms?loginId=${data.loginId}`,
    method: "post",
  });
}

interface getCaptchaProps {
  loginId?: string | number;
}
export function getCaptcha(data: getCaptchaProps) {
  return getService()({
    url: `/Account/getcaptcha?loginId=${data.loginId}`,
    method: "post",
  });
}
interface dolatLoginProps {
  loginId?: string | number;
}
export function dolatLogin(data: dolatLoginProps) {
  return getService()({
    url: `/Account/GoToSSo?loginId=${data.loginId}`,
    method: "get",
  });
}
